var $da3e708015f0739a$exports = {};
$da3e708015f0739a$exports = {
    "maximum": `\u{CD5C}\u{B300}`,
    "minimum": `\u{CD5C}\u{C18C}`
};


export {$da3e708015f0739a$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
